export default __webpack_public_path__ + "static/media/haymach_hero.5afab398.png";